module.exports = __webpack_public_path__ + "app-static/img/p_03.dd920a13.jpg";